export default __webpack_public_path__ + "static/media/19_mobile.82c4b8f7.jpg";